import * as React from 'react';
import Box from '@mui/material/Box';

import Modal from '@mui/material/Modal';
import RegistroForm from './form';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: '#f3f3f3',
  borderRadius: "0.5em",
  boxShadow: 24,
  p: 2,
  
};

const RegistrarModal: React.FC<{open: boolean, setOpen(value: boolean): void}> = ({open, setOpen}) => {

  const handleClose = () => setOpen(false);

  return (

    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
    <Box sx={style}>
        <RegistroForm/>
    </Box>
    </Modal>

  );
}
export default RegistrarModal;